import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['bookingField']

  // STT and STC set the booking ID via a Shipment Number
  // through flex fields on the Truck Gate In form.
  handleSelect(event) {
    const bookingId = event.detail.bookingId;
    if (this.hasBookingFieldTarget) this.bookingFieldTarget.value = bookingId;
  }

  handleClear() {
    if (this.hasBookingFieldTarget) this.bookingFieldTarget.value = "";
  }
}
